"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionMatchingPattern = void 0;
var ChargingSessionMatchingPattern;
(function (ChargingSessionMatchingPattern) {
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["MembershipToken"] = 1] = "MembershipToken";
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["PaymentToken"] = 2] = "PaymentToken";
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["UniqueEvccId"] = 3] = "UniqueEvccId";
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["PlugInTimeProximity"] = 4] = "PlugInTimeProximity";
})(ChargingSessionMatchingPattern = exports.ChargingSessionMatchingPattern || (exports.ChargingSessionMatchingPattern = {}));
